import { Swiper } from 'swiper';

class PanelSwiper {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }
    this.element = element;

    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      on: {
        init: (swiper) => {
          swiper.el.querySelectorAll('.panel').forEach((el) => {
            if (typeof el.panel !== 'undefined') {
              el.panel.getParagraphHeight();
            }
          });
        },
      },
    });
  }
}

export default PanelSwiper;
